const Deals = [
    {
        id: 101,
        name: "2x1 Tuesdays",
        desc: "Buy one pizza and get the second one free every Tuesday.",
        image: "https://images.pexels.com/photos/2147491/pexels-photo-2147491.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        originalPrice: 13.99,
        discountedPrice: 6.99,
        badge: "50% OFF"
    },
    {
        id: 102,
        name: "Family Deal",
        desc: "Two large pizzas, garlic bread, and four drinks for the whole family.",
        image: "https://images.pexels.com/photos/4109111/pexels-photo-4109111.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        originalPrice: 49.99,
        discountedPrice: 39.99,
        badge: "20% OFF"
    },
    {
        id: 103,
        name: "Pizza of the Day",
        desc: "A different specialty pizza featured each day at a special price.",
        image: "https://images.pexels.com/photos/3915857/pexels-photo-3915857.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        originalPrice: 12.99,
        discountedPrice: 10.25,
        badge: "21% OFF"
    }
];

export default Deals;
